import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const PhoneWrap = styled.div.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${(scroll) * 12}%)`,
  }),
})`
transition: transform 0.2s ease-out;
position: absolute;
bottom:-70vh;
left: 0vw;
/* border: 1px dashed red; */
height: 80vh;
`;

const CardWrap = styled.div.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${(scroll) * 4}%) scale(0.75)`,
  }),
})`
transition: transform 0.2s ease-out;
bottom: -50vh;
right: 0vw;
position: absolute;
/* border: 1px dashed red; */
height: 80vh;
`;

const PhoneMockup = () => (
  <svg viewBox="0 0 300 620" height="100%" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="300" height="620" rx="42" fill="#0B1F3A" />
    <rect x="10" y="12" width="280" height="596" rx="32" fill="#F5F8F7" />
    <rect x="112" y="12" width="76" height="16" rx="8" fill="#0B1F3A" />
    <rect x="10" y="32" width="280" height="96" fill="#0FA968" />
    <text x="32" y="70" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="700" fill="#FFFFFF">Mutual Funds</text>
    <text x="32" y="96" fontFamily="Arial, sans-serif" fontSize="13" fill="#E4F7EE">Invest BharatPe</text>
    <text x="32" y="160" fontFamily="Arial, sans-serif" fontSize="13" fill="#7C8B88">Portfolio Value</text>
    <text x="32" y="196" fontFamily="Arial, sans-serif" fontSize="32" fontWeight="700" fill="#0B1F3A">
      &#8377;1,24,850
    </text>
    <rect x="32" y="210" width="88" height="26" rx="13" fill="#E4F7EE" />
    <text x="48" y="228" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="700" fill="#0FA968">+12.4%</text>
    <polyline points="32,300 76,282 120,292 164,258 208,268 252,224 268,236" fill="none" stroke="#0FA968" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="268" cy="236" r="5" fill="#0FA968" />
    <line x1="32" y1="330" x2="268" y2="330" stroke="#E3E8E7" strokeWidth="1" />
    <circle cx="50" cy="368" r="16" fill="#FFB020" />
    <rect x="80" y="358" width="110" height="10" rx="5" fill="#0B1F3A" opacity="0.85" />
    <rect x="80" y="374" width="70" height="8" rx="4" fill="#C3CBC9" />
    <text x="268" y="374" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="700" fill="#0FA968" textAnchor="end">+8.2%</text>
    <circle cx="50" cy="428" r="16" fill="#3D7BF5" />
    <rect x="80" y="418" width="120" height="10" rx="5" fill="#0B1F3A" opacity="0.85" />
    <rect x="80" y="434" width="60" height="8" rx="4" fill="#C3CBC9" />
    <text x="268" y="434" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="700" fill="#0FA968" textAnchor="end">+3.6%</text>
    <circle cx="50" cy="488" r="16" fill="#8E5CF7" />
    <rect x="80" y="478" width="100" height="10" rx="5" fill="#0B1F3A" opacity="0.85" />
    <rect x="80" y="494" width="80" height="8" rx="4" fill="#C3CBC9" />
    <text x="268" y="494" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="700" fill="#E5484D" textAnchor="end">-1.1%</text>
    <rect x="10" y="548" width="280" height="60" fill="#FFFFFF" />
    <circle cx="80" cy="578" r="10" fill="#0FA968" />
    <circle cx="140" cy="578" r="10" fill="#E3E8E7" />
    <circle cx="200" cy="578" r="10" fill="#E3E8E7" />
    <circle cx="260" cy="578" r="10" fill="#E3E8E7" />
  </svg>
);

const StatCard = () => (
  <svg viewBox="0 0 320 260" height="100%" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="312" height="252" rx="24" fill="#FFFFFF" stroke="#E3E8E7" strokeWidth="1" />
    <text x="28" y="42" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="700" fill="#0B1F3A">Investment Journey</text>
    <text x="28" y="62" fontFamily="Arial, sans-serif" fontSize="12" fill="#7C8B88">Steps to invest</text>
    <text x="28" y="92" fontFamily="Arial, sans-serif" fontSize="12" fill="#B9C2C0">Before</text>
    <rect x="90" y="80" width="16" height="16" rx="3" fill="#E3E8E7" />
    <rect x="112" y="80" width="16" height="16" rx="3" fill="#E3E8E7" />
    <rect x="134" y="80" width="16" height="16" rx="3" fill="#E3E8E7" />
    <rect x="156" y="80" width="16" height="16" rx="3" fill="#E3E8E7" />
    <rect x="178" y="80" width="16" height="16" rx="3" fill="#E3E8E7" />
    <rect x="200" y="80" width="16" height="16" rx="3" fill="#E3E8E7" />
    <rect x="222" y="80" width="16" height="16" rx="3" fill="#E3E8E7" />
    <text x="28" y="132" fontFamily="Arial, sans-serif" fontSize="12" fill="#0FA968">After</text>
    <rect x="90" y="120" width="16" height="16" rx="3" fill="#0FA968" />
    <rect x="112" y="120" width="16" height="16" rx="3" fill="#0FA968" />
    <rect x="134" y="120" width="16" height="16" rx="3" fill="#0FA968" />
    <rect x="156" y="120" width="16" height="16" rx="3" fill="#0FA968" />
    <text x="28" y="188" fontFamily="Arial, sans-serif" fontSize="40" fontWeight="700" fill="#0FA968">30%</text>
    <text x="94" y="182" fontFamily="Arial, sans-serif" fontSize="13" fill="#0B1F3A">faster homepage</text>
    <text x="94" y="198" fontFamily="Arial, sans-serif" fontSize="13" fill="#0B1F3A">load time</text>
    <rect x="28" y="212" width="264" height="28" rx="14" fill="#E4F7EE" />
    <text x="42" y="230" fontFamily="Arial, sans-serif" fontSize="11" fill="#0FA968">Module Federation &#183; Microfrontends</text>
  </svg>
);

class BharatPeImages extends Component {
  render() {
    let { scrollPercent } = this.props;
    const {
      boxHeight, index, scrollHeight, screenHeight,
    } = this.props;
    const heighttoBeReducedinVH = ((boxHeight * index) - 100);
    const scrollOffset = (screenHeight * heighttoBeReducedinVH) / 100;
    const scrollOffsetInPercent = (scrollOffset * 100 / scrollHeight) + index - 1;
    scrollPercent -= scrollOffsetInPercent;

    return (
      <React.Fragment>
        <CardWrap scroll={scrollPercent}><StatCard /></CardWrap>
        <PhoneWrap scroll={scrollPercent}><PhoneMockup /></PhoneWrap>
      </React.Fragment>
    );
  }
}

BharatPeImages.propTypes = {
  boxHeight: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  screenHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollPercent: PropTypes.number.isRequired,
};

export default BharatPeImages;
